import { ImageDefinition } from '@/models/image-definition';
import { Journey } from '@/models/journey';
import { Mark } from '@/util/markdown';
import { PathSegment } from './path-segment';

export class SimplePathSegment extends PathSegment {
   public readonly description?: string;
   public readonly image?: ImageDefinition;
   public readonly icon?: string;

   constructor(
      type = 'SimplePathSegment',
      title: string,
      alias: string,
      price: number,
      showPrice: boolean,
      isCostExternal: boolean,
      description?: string,
      image?: ImageDefinition,
      icon?: string,
      dataObject?: Journey,
      children?: Array<PathSegment>) {
      super(type, title, alias, price, showPrice, isCostExternal, children, dataObject);

      this.description = !!description
         ? Mark.Down.render(description)
         : undefined;
      this.image = image;
      this.icon = icon;
   }
}
